// lib/modelist/ranges.ts
/** A change to a set of settings with every number held inside its range; one that is no number is left out. */
export const heldInRanges = <T extends object>(ranges: Partial<Record<keyof T, { min: number; max: number }>>, patch: Partial<T>): Partial<T> => {
  const next = { ...patch };
  for (const key of Object.keys(ranges) as Array<keyof T>) {
    const value = next[key];
    if (value === undefined) continue;
    if (typeof value === 'number' && Number.isFinite(value)) next[key] = Math.min(ranges[key]!.max, Math.max(ranges[key]!.min, value)) as T[keyof T];
    else delete next[key];
  }
  return next;
};
